<template>
  <div class="scroll-pane-wrapper" ref="scrollWrapper">
    <div class="scroll-pane-container" ref="scrollContainer">
      <slot></slot>
    </div>
    <!-- 滚动条 -->
    <div
      v-show="showScrollBar"
      class="scroll-bar"
      :style="{
        width: scrollBarWidth + 'px',
        left: scrollBarLeft + 'px'
      }"
      @mousedown.prevent="onScrollBarMouseDown"
    ></div>
    <!-- 滚动按钮 -->
    <div
      v-show="showLeftBtn"
      class="scroll-btn left"
      @mousedown.prevent="startScroll('left')"
    >
      <i class="el-icon-arrow-left"></i>
    </div>
    <div
      v-show="showRightBtn"
      class="scroll-btn right"
      @mousedown.prevent="startScroll('right')"
    >
      <i class="el-icon-arrow-right"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScrollPane',
  data() {
    return {
      scrollLeft: 0, // 滚动容器的scrollLeft
      scrollWidth: 0, // 滚动容器的scrollWidth
      clientWidth: 0, // 滚动容器的clientWidth
      scrollBarWidth: 0, // 滚动条的宽度
      scrollBarLeft: 0, // 滚动条的left位置
      showScrollBar: false, // 是否显示滚动条
      showLeftBtn: false, // 是否显示左滚动按钮
      showRightBtn: false, // 是否显示右滚动按钮
      scrollTimer: null, // 滚动定时器
      scrollBarMouseDown: false, // 滚动条是否被鼠标按下
      scrollBarMouseX: 0, // 鼠标按下时的X坐标
      scrollBarScrollLeft: 0 // 鼠标按下时的scrollLeft
    }
  },
  mounted() {
    // 初始化滚动容器的尺寸
    this.initScrollSize()
    // 监听滚动事件
    this.$refs.scrollContainer.addEventListener('scroll', this.onScroll)
    // 监听窗口 resize 事件
    window.addEventListener('resize', this.onResize)
    // 监听鼠标移动事件
    window.addEventListener('mousemove', this.onMouseMove)
    // 监听鼠标抬起事件
    window.addEventListener('mouseup', this.onMouseUp)
  },
  beforeDestroy() {
    // 清除滚动定时器
    if (this.scrollTimer) {
      clearInterval(this.scrollTimer)
      this.scrollTimer = null
    }
    // 移除事件监听
    this.$refs.scrollContainer.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('resize', this.onResize)
    window.removeEventListener('mousemove', this.onMouseMove)
    window.removeEventListener('mouseup', this.onMouseUp)
  },
  methods: {
    // 初始化滚动容器的尺寸
    initScrollSize() {
      const scrollContainer = this.$refs.scrollContainer
      this.scrollWidth = scrollContainer.scrollWidth
      this.clientWidth = scrollContainer.clientWidth
      this.scrollLeft = scrollContainer.scrollLeft
      // 更新滚动条的状态
      this.updateScrollBar()
      // 更新滚动按钮的状态
      this.updateScrollBtn()
    },
    // 更新滚动条的状态
    updateScrollBar() {
      // 如果滚动容器的宽度小于内容的宽度，则显示滚动条
      this.showScrollBar = this.clientWidth < this.scrollWidth
      if (this.showScrollBar) {
        // 计算滚动条的宽度
        this.scrollBarWidth = Math.max(20, Math.min(100, (this.clientWidth / this.scrollWidth) * this.clientWidth))
        // 计算滚动条的left位置
        this.scrollBarLeft = (this.scrollLeft / (this.scrollWidth - this.clientWidth)) * (this.clientWidth - this.scrollBarWidth)
      }
    },
    // 更新滚动按钮的状态
    updateScrollBtn() {
      // 如果滚动容器可以向左滚动，则显示左滚动按钮
      this.showLeftBtn = this.scrollLeft > 0
      // 如果滚动容器可以向右滚动，则显示右滚动按钮
      this.showRightBtn = this.scrollLeft < (this.scrollWidth - this.clientWidth)
    },
    // 滚动事件处理函数
    onScroll() {
      this.scrollLeft = this.$refs.scrollContainer.scrollLeft
      // 更新滚动条的状态
      this.updateScrollBar()
      // 更新滚动按钮的状态
      this.updateScrollBtn()
    },
    // 窗口 resize 事件处理函数
    onResize() {
      // 重新初始化滚动容器的尺寸
      this.initScrollSize()
    },
    // 鼠标移动事件处理函数
    onMouseMove(e) {
      // 如果滚动条被鼠标按下，则移动滚动条
      if (this.scrollBarMouseDown) {
        const deltaX = e.clientX - this.scrollBarMouseX
        const deltaScrollLeft = (deltaX / (this.clientWidth - this.scrollBarWidth)) * (this.scrollWidth - this.clientWidth)
        this.$refs.scrollContainer.scrollLeft = this.scrollBarScrollLeft + deltaScrollLeft
      }
    },
    // 鼠标抬起事件处理函数
    onMouseUp() {
      // 取消滚动条被鼠标按下的状态
      this.scrollBarMouseDown = false
    },
    // 滚动条鼠标按下事件处理函数
    onScrollBarMouseDown(e) {
      // 设置滚动条被鼠标按下的状态
      this.scrollBarMouseDown = true
      // 记录鼠标按下时的X坐标
      this.scrollBarMouseX = e.clientX
      // 记录鼠标按下时的scrollLeft
      this.scrollBarScrollLeft = this.$refs.scrollContainer.scrollLeft
    },
    // 开始滚动
    startScroll(direction) {
      // 清除之前的滚动定时器
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer)
      }
      // 设置滚动速度
      const scrollSpeed = 10
      // 开始滚动定时器
      this.scrollTimer = setInterval(() => {
        let scrollLeft = this.$refs.scrollContainer.scrollLeft
        // 根据滚动方向调整scrollLeft
        if (direction === 'left') {
          scrollLeft -= scrollSpeed
          if (scrollLeft < 0) {
            scrollLeft = 0
            // 清除滚动定时器
            clearInterval(this.scrollTimer)
            this.scrollTimer = null
          }
        } else if (direction === 'right') {
          scrollLeft += scrollSpeed
          if (scrollLeft > (this.scrollWidth - this.clientWidth)) {
            scrollLeft = this.scrollWidth - this.clientWidth
            // 清除滚动定时器
            clearInterval(this.scrollTimer)
            this.scrollTimer = null
          }
        }
        // 设置滚动容器的scrollLeft
        this.$refs.scrollContainer.scrollLeft = scrollLeft
      }, 16)
    },
    // 滚动到目标元素
    moveToTarget(target) {
      const scrollContainer = this.$refs.scrollContainer
      const targetLeft = target.offsetLeft
      const targetWidth = target.offsetWidth
      const scrollLeft = scrollContainer.scrollLeft
      const clientWidth = scrollContainer.clientWidth
      let newScrollLeft = scrollLeft
      // 如果目标元素在可视区域的左侧，则滚动到目标元素的左侧
      if (targetLeft < scrollLeft) {
        newScrollLeft = targetLeft
      }
      // 如果目标元素在可视区域的右侧，则滚动到目标元素的右侧
      else if (targetLeft + targetWidth > scrollLeft + clientWidth) {
        newScrollLeft = targetLeft + targetWidth - clientWidth
      }
      // 设置滚动容器的scrollLeft
      scrollContainer.scrollLeft = newScrollLeft
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  // 滚动容器包装器的样式
  .scroll-pane-wrapper {
    position: relative;
    height: 100%;
    overflow: hidden;
    // 滚动容器的样式
    .scroll-pane-container {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      overflow-x: scroll;
      overflow-y: hidden;
      // 隐藏滚动条
      &::-webkit-scrollbar {
        display: none;
      }
      -ms-overflow-style: none;
      scrollbar-width: none;
    }
    // 滚动条的样式
    .scroll-bar {
      position: absolute;
      bottom: 0;
      height: 4px;
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 2px;
      cursor: pointer;
      transition: all 0.2s ease;
      // 滚动条悬停时的样式
      &:hover {
        background-color: rgba(0, 0, 0, 0.3);
      }
    }
    // 滚动按钮的样式
    .scroll-btn {
      position: absolute;
      top: 0;
      height: 100%;
      width: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(255, 255, 255, 0.8);
      cursor: pointer;
      transition: all 0.2s ease;
      // 滚动按钮悬停时的样式
      &:hover {
        background-color: rgba(255, 255, 255, 1);
      }
      // 左滚动按钮的样式
      &.left {
        left: 0;
        border-right: 1px solid #e6e6e6;
      }
      // 右滚动按钮的样式
      &.right {
        right: 0;
        border-left: 1px solid #e6e6e6;
      }
      // 滚动按钮图标的样式
      i {
        font-size: 16px;
        color: #999;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/TagsView/ScrollPane.vue